import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { useCartState } from '../cart-provider';

export const useCartContext = () => {
  const [cartState, setCartState] = useCartState();
  const { cartEntries } = useMinimalCart();
  const isDiagnosticsEnabled = useFlag(LaunchDarklyFlag.ENABLE_INTERNAL_DIAGNOSTIC_TOOLS);
  const isEditOfferButtonEnabled = useFlag(LaunchDarklyFlag.ENABLE_EDIT_OFFERS_CART_BUTTON);
  const isRewardUnstackingEnabled = useFlag(LaunchDarklyFlag.ENABLE_REWARD_UNSTACKING);
  const isDonationsEnabled = useFlag(LaunchDarklyFlag.ENABLE_FOUNDATION_DONATIONS);
  const isCartCancelEnabled = useFlag(LaunchDarklyFlag.ENABLE_CART_CANCELLATION_POLICY);

  return {
    ...cartState,
    setCartState,
    cartEntries,

    // Flags
    isDiagnosticsEnabled,
    isEditOfferButtonEnabled,
    isRewardUnstackingEnabled,
    isDonationsEnabled,
    isCartCancelEnabled,
  };
};
